"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ValidationError = require("./ValidationError");

var _ValidationError2 = _interopRequireDefault(_ValidationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          label = _props.label,
          fieldProps = _props.fieldProps;

      var hasError = fieldProps.touched && fieldProps.error;
      var formGroupClasses = "form-group";
      if (hasError) {
        formGroupClasses += " has-error";
      }
      return _react2.default.createElement(
        "div",
        { className: formGroupClasses },
        _react2.default.createElement(
          "label",
          { className: "placeholder" },
          "\xA0"
        ),
        _react2.default.createElement(
          "div",
          { className: "checkbox" },
          _react2.default.createElement("input", (0, _extends3.default)({ id: id, type: "checkbox" }, fieldProps)),
          _react2.default.createElement(
            "label",
            { htmlFor: id },
            label
          )
        ),
        _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps }),
        this.props.children
      );
    }
  }]);
  return Checkbox;
}(_react.Component), _class.propTypes = {
  id: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  fieldProps: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.object
}, _temp);
exports.default = Checkbox;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/Checkbox.js
 ** module id = 133
 ** module chunks = 0
 **/